import cx from 'clsx';
import React from 'react';

import style from './style.module.scss';

interface IProps {
  className?: string;
}

const SkeletonBlock: React.FC<IProps> = ({ className }) => {
  return <span className={cx(style.skeletonBlock, className)}></span>;
};

export default SkeletonBlock;
